import { createContext, useContext } from 'react'

type BrowsePopoverContextValue = {
  open: boolean
  close: () => void
}

export const BrowsePopoverContext = createContext<BrowsePopoverContextValue | null>(null)

export function useBrowsePopover() {
  return useContext(BrowsePopoverContext)
}
